import { lazy, Suspense, useEffect } from 'react';
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Landing from './website/pages/Landing.jsx';
import ErrorBoundary from './shared/components/ErrorBoundary.jsx';
import ConstructionGate from './shared/components/ConstructionGate.jsx';

const Dashboard = lazy(() => import('./dashboard/pages/Dashboard.jsx'));
const Legal = lazy(() => import('./website/pages/Legal.jsx'));

function LanguageDetector() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname !== '/') return;
    if (sessionStorage.getItem('lang-detected')) return;
    sessionStorage.setItem('lang-detected', '1');
    const browserLang = (navigator.language || '').toLowerCase();
    if (browserLang.startsWith('fr')) {
      navigate('/fr', { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
}

export default function App() {
  return (
    <HelmetProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <LanguageDetector />
          <Suspense fallback={<div className="state">Loading…</div>}>
            <Routes>
              <Route path="/dashboard" element={<Dashboard />} />
              <Route
                path="*"
                element={
                  <ConstructionGate>
                    <Routes>
                      <Route path="/" element={<Landing />} />
                      <Route path="/legal" element={<Legal />} />
                      <Route path="/fr" element={<Landing />} />
                      <Route path="/fr/legal" element={<Legal />} />
                    </Routes>
                  </ConstructionGate>
                }
              />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </ErrorBoundary>
    </HelmetProvider>
  );
}
